// import ListIcon from "@mui/icons-material/List";
// import CorporateFareIcon from "@mui/icons-material/CorporateFare";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import MultiLanTxt from "../Components/UI/MultiLanTxt/MultiLanTxt";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import SaveAsIcon from "@mui/icons-material/SaveAs";
// import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
// import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
// import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
// import DatasetOutlinedIcon from "@mui/icons-material/DatasetOutlined";
// import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
// import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
// import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
// import LocationCityRoundedIcon from "@mui/icons-material/LocationCityRounded";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
// import SchemaIcon from "@mui/icons-material/Schema";
// import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
// import Person3OutlinedIcon from "@mui/icons-material/Person3Outlined";
// import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";
// import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
// import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
// import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import { ReactComponent as AccountGroup } from "../images/icons/sidebar/group.svg";
import { ReactComponent as ChartLogo } from "../images/icons/sidebar/chart-icon.svg";
import { ReactComponent as AccessLogo } from "../images/icons/sidebar/access-icon.svg";
import MapIcon from "@mui/icons-material/Map";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import SecurityIcon from "@mui/icons-material/Security";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import FollowTheSignsOutlinedIcon from "@mui/icons-material/FollowTheSignsOutlined";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import MultiLanTxt from "../Components/UI/MultiLanTxt/MultiLanTxt";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import { ReactComponent as DBACLogo } from "../images/icons/sidebar/databaseV1.svg";

// ===========================================================================***SUB ITEMS OF SUB ITEMS***===========================================================================
// const gozaresheMorakhasiItems = [
//   {
//     id: 44421321,
//     label: <MultiLanTxt tid="LeaveGroupReviewForm" />,
//     to: "/leave-group-review-form",
//   },
//   {
//     id: 9685923132,
//     label: <MultiLanTxt tid="LEAVE_REPORT_ON_CERTAIN_DATE" />,
//     to: "/leave-report-on-certain-date",
//   },
//   {
//     id: 997643,
//     label: <MultiLanTxt tid="COMPARATIVE_REPORT" />,
//     to: "/comparative-report",
//   },
//   {
//     id: 52214846,
//     label: <MultiLanTxt tid="USER_LEAVE_HISTORY" />,
//     to: "/user-leave-history",
//   },
// ];
// ===========================================================================***CORE SUSTEM ITEMS***===========================================================================
// const processItems = [
//   {
//     id: 8882054753,
//     label: <MultiLanTxt tid="ABSTRACT_PROCESS" />,
//     to: "/process",
//     items: [],
//     name: "Process",
//   },

//   {
//     id: 89754621953,
//     label: "Process Instance",
//     to: "/process-instance",
//     items: [],
//     name: "ProcessInstance",
//   },
// ];
// const chartItems = [
//   {
//     id: 985522010,
//     label: <MultiLanTxt tid="BusinessUnit" />,
//     to: "/core-system-business-unit",
//     items: [],
//     name: "CoreSystemBusinessUnit",
//   },
// ];
// const entityItems = [
//   {
//     id: 558000741,
//     label: "Entity",
//     to: "/entity",
//     items: [],
//     name: "Entity",
//   },
//   {
//     id: 55201167,
//     label: "Field",
//     to: "/field",
//     items: [],
//     name: "Field",
//   },
// ];
// const userItems = [
//   {
//     id: 4654654654,
//     label: "User",
//     to: "/user",
//     items: [],
//     name: "PublicUser",
//   },
//   {
//     id: 7987987987,
//     label: "Personnel",
//     to: "/personnel",
//     items: [],
//     name: "Personnel",
//   },
//   {
//     id: 7985151562627,
//     label: "Person",
//     to: "/core-system-person",
//     items: [],
//     name: "CoreSystemPerson",
//   },
//   {
//     id: 848439267,
//     label: "Personnel Role",
//     to: "/personnel-role",
//     items: [],
//     name: "PersonnelRole",
//   },
// ];
const generalChartItems = [
  {
    id: 798796546513,
    label: "Super Admin Chart",
    to: "/super-admin-chart",
    items: [],
    name: "SuperAdminChart",
  },
  {
    id: 254652136548,
    label: "People Admin Chart",
    to: "/people-admin-chart",
    items: [],
    name: "PeopleAdminChart",
  },
  {
    id: 84120051,
    label: "Chart Admin Chart",
    to: "/chart-admin-chart",
    items: [],
    name: "ChartAdminChart",
  },
  {
    id: 33549912,
    label: "System Admin Chart",
    to: "/system-admin-chart",
    items: [],
    name: "SystemAdminChart",
  },
  {
    id: 9517546282354,
    label: "Software Admin Chart",
    to: "/software-admin-chart",
    items: [],
    name: "SoftwareAdminChart",
  },
  {
    id: 879121,
    label: "Chart And Auxiliary Admin Chart",
    to: "/chart-and-auxiliary-admin-chart",
    items: [],
    name: "ChartAndAuxiliaryAdminChart",
  },
  {
    id: 999888514,
    label: "Process Admin Chart",
    to: "/process-admin-chart",
    items: [],
    name: "ProcessAdminChart",
  },
  {
    id: 8850126,
    label: "Staff Admin Chart",
    to: "/staff-admin-chart",
    items: [],
    name: "StaffAdminChart",
  },
  {
    id: 9874651200,
    label: "Staff Definer Of Financial Department Chart",
    to: "/staff-definer-of-financial-department-chart",
    items: [],
    name: "StaffDefinerOfFinancialDepartmentChart",
  },
  {
    id: 99877154,
    label: "Staff Definer Of Logistic Department Chart",
    to: "/staff-definer-of-logistic-department-chart",
    items: [],
    name: "StaffDefinerOfLogisticDepartmentChart",
  },
  {
    id: 999811101,
    label: "Staff Definer Of Sale Department Chart",
    to: "/staff-definer-of-sale-department-chart",
    items: [],
    name: "StaffDefinerOfSaleDepartmentChart",
  },
];
const dbacItems = [
  {
    id: 498951651,
    label: "Chart Dbac",
    to: "/chart-dbac",
    items: [],
    name: "AdvancedChartDbacProtocol",
  },
  {
    id: 9885490,
    label: "Non User Dbac",
    to: "/non-user-dbac",
    items: [],
    name: "AdvancedNonUserDbacProtocol",
  },
  {
    id: 498484,
    label: "Organizational Title Dbac",
    to: "/organizational-title-dbac",
    items: [],
    name: "AdvancedOrganizationalTitleDbacProtocol",
  },
  {
    id: 1212123,
    label: "User Dbac",
    to: "/user-dbac",
    items: [],
    name: "AdvancedUserDbacProtocol",
  },
];
const dmacItems = [
  {
    id: 1212356777,
    label: "Chart Dmac",
    to: "/chart-dmac",
    items: [],
    name: "ChartDmacProtocol",
  },
  {
    id: 88865,
    label: "Non User Dmac",
    to: "/non-user-dmac",
    items: [],
    name: "NonUserDmacProtocol",
  },
  {
    id: 34445555,
    label: "Organizational Title Dmac",
    to: "/organizational-title-dmac",
    items: [],
    name: "OrganizationalTitleDmacProtocol",
  },
  {
    id: 77743,
    label: "User Dmac",
    to: "/user-dmac",
    items: [],
    name: "UserDmacProtocol",
  },
];
const generalStaffItems = [
  {
    id: 87152233,
    label: "Super Admin Staff",
    to: "/super-admin-staff",
    items: [],
    name: "SuperAdminStaff",
  },
  {
    id: 154867,
    label: "People Admin Staff",
    to: "/people-admin-staff",
    items: [],
    name: "PeopleAdminStaff",
  },
  {
    id: 948236,
    label: "System Admin Staff",
    to: "/system-admin-staff",
    items: [],
    name: "SystemAdminStaff",
  },
  {
    id: 1023,
    label: "Software Admin Staff",
    to: "/software-admin-staff",
    items: [],
    name: "SoftwareAdminStaff",
  },
  {
    id: 999877,
    label: "Chart And Auxiliary Admin Staff",
    to: "/chart-and-auxiliary-admin-staff",
    items: [],
    name: "ChartAndAuxiliaryAdminStaff",
  },
  {
    id: 9998885211,
    label: "Process Admin Staff",
    to: "/process-admin-staff",
    items: [],
    name: "ProcessAdminStaff",
  },
  {
    id: 99647,
    label: "Staff Admin Staff",
    to: "/staff-admin-staff",
    items: [],
    name: "StaffAdminStaff",
  },
  {
    id: 7816,
    label: "Chart Admin Staff",
    to: "/chart-admin-staff",
    items: [],
    name: "ChartAdminStaff",
  },
  {
    id: 653154774,
    label: "Staff Definer Of Sale Department Staff",
    to: "/staff-definer-of-sale-department-staff",
    items: [],
    name: "StaffDefinerOfSaleDepartmentStaff",
  },
  {
    id: 44000156,
    label: "Staff Definer Of Logistic Department Staff",
    to: "/staff-definer-of-logistic-department-staff",
    items: [],
    name: "StaffDefinerOfLogisticDepartmentStaff",
  },
  {
    id: 44444111009,
    label: "Staff Definer Of Financial Department Staff",
    to: "/staff-definer-of-financial-department-staff",
    items: [],
    name: "StaffDefinerOfFinancialDepartmentStaff",
  },
];
const ospStaffItems = [
  {
    id: 753420793,
    label: "Chief Management Staff",
    to: "/chief-management-staff",
    items: [],
    name: "ChiefManagementStaff",
  },
  {
    id: 798700542,
    label: "Sale Person Staff",
    to: "/sale-person-staff",
    items: [],
    name: "SalePersonStaff",
  },
  {
    id: 78787846465,
    label: "Logistic Staff",
    to: "/logistic-staff",
    items: [],
    name: "LogisticStaff",
  },
];
const ospChartItems = [
  {
    id: 875315953,
    label: "Chief Management Chart",
    to: "/chief-management-chart",
    items: [],
    name: "ChiefManagementChart",
  },
  {
    id: 11544493,
    label: "Sale Person Chart",
    to: "/sale-person-chart",
    items: [],
    name: "SalePersonChart",
  },
  {
    id: 11223794604,
    label: "Logistic Chart",
    to: "/logistic-chart",
    items: [],
    name: "LogisticChart",
  },
];
const pacStaffItems = [
  {
    id: 753420793,
    label: "کاربران خزانه داری",
    to: "/posAccountControl/treasurer-staff",
    items: [],
    name: "TreasurerStaff",
  },
  {
    id: 798700542,
    label: "کاربران تحصیلداری",
    to: "/posAccountControl/collector-staff",
    items: [],
    name: "CollectorStaff",
  },
];
const pacChartItems = [
  {
    id: 875315953,
    label: "جایگاه‌های سازمانی خزانه داری",
    to: "/posAccountControl/treasurer-chart",
    items: [],
    name: "TreasurerChart",
  },
  {
    id: 11544493,
    label: "جایگاه‌های سازمانی تحصیلداری",
    to: "/posAccountControl/collector-chart",
    items: [],
    name: "CollectorChart",
  },
];
const accessItems = [
  {
    id: 4654654654,
    label: "Entity Config",
    to: "/general/entity-config",
    items: [],
    name: "EntityConfig",
  },
  {
    id: 7987987987,
    label: "Field Config",
    to: "/general/field-config/edit",
    items: [],
    name: "FieldConfig",
  },
];
const baseInformationItems = [
  {
    id: 46521381463,
    label: <MultiLanTxt tid="BUSINESS_UNIT" />,
    to: "/binf/business-unit",
    items: [],
    name: "BusinessUnit",
  },
  // {
  //   id: 1155632448,
  //   label: <MultiLanTxt tid="SHAREHOLDERS" />,
  //   to: "/binf/shareholder",
  //   items: [],
  //   name: "BURelation",
  // },
  // {
  //   id: 7744236651,
  //   label: <MultiLanTxt tid="UNDER_POSSITIONS" />,
  //   to: "/binf/under-possesion",
  //   items: [],
  //   name: "BURelation",
  // },
];
const organizationItems = [
  {
    id: 755555373,
    name: "Organization",
    label: <MultiLanTxt tid="ORGANIZATIONS" />,
    to: "/binf/organization",
    items: [],
  },
  {
    id: 4534532045,
    name: "OrganizationTag",
    label: <MultiLanTxt tid="ORGANIZATION_TAGS" />,
    to: "/binf/organization-tag",
    items: [],
  },
];
const officeItems = [
  {
    id: 496645314,
    name: "Office",
    label: <MultiLanTxt tid="OFFICE" />,
    to: "/binf/office",
    items: [],
  },
  {
    id: 7987954213280,
    name: "OfficeType",
    label: <MultiLanTxt tid="OFFICE_TYPE" />,
    to: "/binf/office-type",
    items: [],
  },
];
const calendarItems = [
  {
    id: 1159663748,
    label: <MultiLanTxt tid="OCCASIONS" />,
    to: "/binf/annual-occasion",
    items: [],
    name: "AnnualOccasion",
  },
  {
    id: 587684321345,
    label: <MultiLanTxt tid="OCCASION_TAGS" />,
    to: "/binf/annual-occasion-tag",
    items: [],
    name: "AnnualOccasionTag",
  },
  {
    id: 220022002200,
    label: <MultiLanTxt tid="WEEKLY_HOLIDAY" />,
    to: "/binf/weekly-holiday",
    items: [],
    name: "WeeklyHoliday",
  },
  {
    id: 555066662,
    label: <MultiLanTxt tid="ADHOC_HOLIDAYS" />,
    to: "/binf/adhoc-holiday",
    items: [],
    name: "AdhocHoliday",
  },
];
const titleItems = [
  {
    id: 8888555520,
    label: <MultiLanTxt tid="ADDRESS_TYPES" />,
    to: "/binf/address-type",
    items: [],
    name: "AddressType",
  },
  {
    id: 1114744110,
    label: <MultiLanTxt tid="CALL_INFORMATION_TYPES" />,
    to: "/binf/contact-info-type",
    items: [],
    name: "ContactInfoType",
  },
];
const personItems = [
  {
    id: 852585258,
    icon: <FeedOutlinedIcon />,
    label: <MultiLanTxt tid="PERSONS" />,
    to: "/binf/person",
    items: [],
    name: "Person",
  },
  {
    id: 3210123210,
    icon: <FeedOutlinedIcon />,
    label: <MultiLanTxt tid="PERSON_TAGS" />,
    to: "/binf/person-tag",
    items: [],
    name: "PersonTag",
  },
];
const cityAndProvinceItems = [
  {
    id: 987654856749,
    icon: <FeedOutlinedIcon />,
    label: <MultiLanTxt tid="CITY" />,
    to: "/binf/city",
    items: [],
    name: "City",
  },
  {
    id: 1632231548,
    icon: <FeedOutlinedIcon />,
    label: <MultiLanTxt tid="PROVINCE" />,
    to: "/binf/province",
    items: [],
    name: "Province",
  },
];
const personAdminItems = [
  {
    id: 1112335898,
    label: "BINF Person Admin Staff",
    to: "/binf/binf-person-admin-staff",
    items: [],
    name: "BINFPersonAdminStaff",
  },
  {
    id: 7753753753,
    label: "BINF Person Admin Chart",
    to: "/binf/binf-person-admin-chart",
    items: [],
    name: "BINFPersonAdminChart",
  },
];
const businessUnitAdminItems = [
  {
    id: 888795461388,
    label: "BINF Business Admin Chart",
    to: "/binf/binf-business-admin-chart",
    items: [],
    name: "BINFBusinessAdminChart",
  },
  {
    id: 159951159519,
    label: "BINF Business Admin Staff",
    to: "/binf/binf-business-admin-staff",
    items: [],
    name: "BINFBusinessAdminStaff",
  },
];
const binfAdminItems = [
  {
    id: 11445223698,
    icon: <FeedOutlinedIcon />,
    label: "Person Admin",
    to: "/binf/person-admin",
    // items: [],
    // name: "BINFPersonAdminChart",
    items: personAdminItems,
    containerOfEntitys: ["BINFPersonAdminChart", "BINFPersonAdminStaff"],
  },
  {
    id: 1455578319,
    icon: <FeedOutlinedIcon />,
    label: "Business Admin",
    to: "/binf/business-unit-admin",
    // items: [],
    // name: "BINFBusinessAdminChart",
    items: businessUnitAdminItems,
    containerOfEntitys: ["BINFBusinessAdminChart", "BINFBusinessAdminStaff"],
  },
];
// ===========================================================================***CMIT ITEMS***===========================================================================
// const ceckItems = [
//   {
//     id: 6764654,
//     label: <MultiLanTxt tid="CHECKS" />,
//     to: "/check",
//     items: [],
//   },
//   {
//     id: 5432577,
//     label: <MultiLanTxt tid="CHECK_HISTORY" />,
//     to: "/check-history",
//     items: [],
//   },
// ];
// // ===========================================================================***HRINF AND HRLP ITEMS***===========================================================================
// const morakhasiKhaliItems = [
//   {
//     id: 11651213748,
//     label: <MultiLanTxt tid="LEAVE_APPLICATION_FORM" />,
//     name: "dddd",
//     to: "/leave-application-form",
//     items: [],
//   },
//   {
//     id: 995236874,
//     label: <MultiLanTxt tid="LEAVE_REPORT" />,
//     name: "aaaa",
//     to: "/leave-report",
//     items: gozaresheMorakhasiItems,
//   },
// ];
// const contractItems = [
//   {
//     id: 116569448,
//     label: <MultiLanTxt tid="Contract" />,
//     name: "Contract",
//     to: "/contract",
//     items: [],
//   },
//   {
//     id: 99849874,
//     label: <MultiLanTxt tid="WORK_CYCLE" />,
//     name: "WorkCycle",
//     to: "/work-cycle",
//     items: [],
//   },
// ];
// ===========================================================================***BINF SUB ITEMS***===========================================================================
// const personAdminItems = [
//   {
//     id: 1112335898,
//     label: "BINF Person Admin Staff",
//     to: "/binf-person-admin-staff",
//     items: [],
//     name: "BINFPersonAdminStaff",
//   },
//   {
//     id: 7753753753,
//     label: "BINF Person Admin Chart",
//     to: "/binf-person-admin-chart",
//     items: [],
//     name: "BINFPersonAdminChart",
//   },
// ];
// const businessUnitAdminItems = [
//   {
//     id: 888795461388,
//     label: "BINF Business Admin Chart",
//     to: "/binf-business-admin-chart",
//     items: [],
//     name: "BINFBusinessAdminChart",
//   },
//   {
//     id: 159951159519,
//     label: "BINF Business Admin Staff",
//     to: "/binf-business-admin-staff",
//     items: [],
//     name: "BINFBusinessAdminStaff",
//   },
// ];
// ===========================================================================***BINF ITEMS***===========================================================================
// const baseInformationItems = [
//   {
//     id: 46521381463,
//     label: <MultiLanTxt tid="BUSINESS_UNIT" />,
//     to: "/business-unit",
//     items: [],
//     name: "BusinessUnit",
//   },
//   // {
//   //   id: 1155632448,
//   //   label: <MultiLanTxt tid="SHAREHOLDERS" />,
//   //   to: "/shareholder",
//   //   items: [],
//   //   name: "BURelation",
//   // },
//   // {
//   //   id: 7744236651,
//   //   label: <MultiLanTxt tid="UNDER_POSSITIONS" />,
//   //   to: "/under-possesion",
//   //   items: [],
//   //   name: "BURelation",
//   // },
// ];
// const organizationItems = [
//   {
//     id: 755555373,
//     name: "Organization",
//     label: <MultiLanTxt tid="ORGANIZATIONS" />,
//     to: "/organization",
//     items: [],
//   },
//   {
//     id: 4534532045,
//     name: "OrganizationTag",
//     label: <MultiLanTxt tid="ORGANIZATION_TAGS" />,
//     to: "/organization-tag",
//     items: [],
//   },
// ];
// const officeItems = [
//   {
//     id: 496645314,
//     name: "Office",
//     label: <MultiLanTxt tid="OFFICE" />,
//     to: "/office",
//     items: [],
//   },
//   {
//     id: 7987954213280,
//     name: "OfficeType",
//     label: <MultiLanTxt tid="OFFICE_TYPE" />,
//     to: "/office-type",
//     items: [],
//   },
// ];
// const calendarItems = [
//   {
//     id: 1159663748,
//     label: <MultiLanTxt tid="OCCASIONS" />,
//     to: "/annual-occasion",
//     items: [],
//     name: "AnnualOccasion",
//   },
//   {
//     id: 587684321345,
//     label: <MultiLanTxt tid="OCCASION_TAGS" />,
//     to: "/annual-occasion-tag",
//     items: [],
//     name: "AnnualOccasionTag",
//   },
//   {
//     id: 220022002200,
//     label: <MultiLanTxt tid="WEEKLY_HOLIDAY" />,
//     to: "/weekly-holiday",
//     items: [],
//     name: "WeeklyHoliday",
//   },
//   {
//     id: 555066662,
//     label: <MultiLanTxt tid="ADHOC_HOLIDAYS" />,
//     to: "/adhoc-holiday",
//     items: [],
//     name: "AdhocHoliday",
//   },
// ];
// const titleItems = [
//   {
//     id: 8888555520,
//     label: <MultiLanTxt tid="ADDRESS_TYPES" />,
//     to: "/address-type",
//     items: [],
//     name: "AddressType",
//   },
//   {
//     id: 1114744110,
//     label: <MultiLanTxt tid="CALL_INFORMATION_TYPES" />,
//     to: "/contact-info-type",
//     items: [],
//     name: "ContactInfoType",
//   },
// ];
// const personItems = [
//   {
//     id: 852585258,
//     icon: <FeedOutlinedIcon />,
//     label: <MultiLanTxt tid="PERSONS" />,
//     to: "/person",
//     items: [],
//     name: "Person",
//   },
//   {
//     id: 3210123210,
//     icon: <FeedOutlinedIcon />,
//     label: <MultiLanTxt tid="PERSON_TAGS" />,
//     to: "/person-tag",
//     items: [],
//     name: "PersonTag",
//   },
// ];
// const cityAndProvinceItems = [
//   {
//     id: 987654856749,
//     icon: <FeedOutlinedIcon />,
//     label: <MultiLanTxt tid="CITY" />,
//     to: "/city",
//     items: [],
//     name: "City",
//   },
//   {
//     id: 1632231548,
//     icon: <FeedOutlinedIcon />,
//     label: <MultiLanTxt tid="PROVINCE" />,
//     to: "/province",
//     items: [],
//     name: "Province",
//   },
// ];
// const binfAdminItems = [
//   {
//     id: 11445223698,
//     icon: <FeedOutlinedIcon />,
//     label: "Person Admin",
//     to: "/person-admin",
//     // items: [],
//     // name: "BINFPersonAdminChart",
//     items: personAdminItems,
//     containerOfEntitys: ["BINFPersonAdminChart", "BINFPersonAdminStaff"],
//   },
//   {
//     id: 1455578319,
//     icon: <FeedOutlinedIcon />,
//     label: "Business Admin",
//     to: "/business-unit-admin",
//     // items: [],
//     // name: "BINFBusinessAdminChart",
//     items: businessUnitAdminItems,
//     containerOfEntitys: ["BINFBusinessAdminChart", "BINFBusinessAdminStaff"],
//   },
// ];

// ===========================================================================***NAVS***===========================================================================
const coreSystemNavs = [
  // {
  //   id: 81514753,
  //   icon: <InboxOutlinedIcon />,
  //   label: "Inbox",
  //   to: "/operation",
  //   items: [],
  //   name: "Operation",
  // },
  {
    id: 159888526,
    icon: <FollowTheSignsOutlinedIcon />,
    label: "Entity",
    to: "/entity",
    items: [],
    name: "Entity",
  },
  {
    id: 2134121325,
    icon: <FollowTheSignsOutlinedIcon />,
    label: "User",
    to: "/general/user",
    items: [],
    name: "User",
  },
  {
    id: 2134101325,
    icon: <FollowTheSignsOutlinedIcon />,
    label: "UserV2",
    to: "/general/userV2",
    items: [],
    name: "User",
  },
  {
    id: 2134101326,
    icon: <FollowTheSignsOutlinedIcon />,
    label: "EnumDefinition",
    to: "/general/enum-definition",
    items: [],
    name: "EnumDefinition",
  },
  {
    id: 2134101305,
    icon: <FollowTheSignsOutlinedIcon />,
    label: "UserGroup",
    to: "/general/user-group",
    items: [],
    name: "UserGroup",
  },
  {
    id: 77740036,
    icon: <FollowTheSignsOutlinedIcon />,
    label: "Task",
    to: "/task",
    items: [],
    name: "Task",
  },
  {
    id: 646851,
    icon: <AccessLogo />,
    label: "Accesses",
    to: "/accesses",
    items: accessItems,
    containerOfEntitys: ["EntityConfig", "FieldConfig"],
  },
  {
    id: 54984965,
    icon: <DBACLogo />,
    label: "Dbac Protocols",
    to: "/dbacs",
    items: dbacItems,
    containerOfEntitys: [
      "AdvancedChartDbacProtocol",
      "AdvancedNonUserDbacProtocol",
      "AdvancedOrganizationalTitleDbacProtocol",
      "AdvancedUserDbacProtocol",
    ],
  },
  {
    id: 115689,
    icon: <DBACLogo />,
    label: "Dmac Protocols",
    to: "/dmacs",
    items: dmacItems,
    containerOfEntitys: [
      "ChartDmacProtocol",
      "NonUserDmacProtocol",
      "OrganizationalTitleDmacProtocol",
      "UserDmacProtocol",
    ],
  },
  {
    id: 99998566,
    icon: <TaskOutlinedIcon />,
    label: "Charts",
    to: "/charts",
    items: generalChartItems,
    containerOfEntitys: [
      "SuperAdminChart",
      "PeopleAdminChart",
      "ChartAdminChart",
      "SystemAdminChart",
      "SoftwareAdminChart",
      "StaffAdminChart",
    ],
  },
  {
    id: 15483467,
    icon: <TaskOutlinedIcon />,
    label: "Staffs",
    to: "/staffs",
    items: generalStaffItems,
    containerOfEntitys: [
      "SuperAdminStaff",
      "PeopleAdminStaff",
      "SystemAdminStaff",
      "SoftwareAdminStaff",
      "StaffAdminStaff",
      "ChartAdminStaff",
    ],
  },
  {
    id: 6874984,
    icon: <SaveAsIcon />,
    label: "Organizational Level",
    to: "/organizational-level",
    items: [],
    name: "OrganizationalLevel",
  },
  {
    id: 6464646464213,
    icon: <SaveAsIcon />,
    label: "Organizational Title",
    to: "/organizational-title",
    items: [],
    name: "OrganizationalTitle",
  },
  {
    id: 6464646464214,
    icon: <SaveAsIcon />,
    label: "Organizational Title Group",
    to: "/organizational-title-group",
    items: [],
    name: "OrganizationalTitleGroup",
  },
  {
    id: 98451321,
    icon: <SaveAsIcon />,
    label: "Process Flow",
    to: "/process-flow",
    items: [],
    name: "ProcessFlow",
  },
  {
    id: 66665,
    icon: <SaveAsIcon />,
    label: "Process Version",
    to: "/process-version",
    items: [],
    name: "ProcessVersion",
  },
  {
    id: 80646464213,
    icon: <SaveAsIcon />,
    label: "Dbac Dmac Candidates",
    to: "/dbac-dmac-candidates",
    items: [],
    name: "Package",
  },
  {
    id: 806462464213,
    icon: <SaveAsIcon />,
    label: "GeneralDacProtocol",
    to: "/general-dac-protocol",
    items: [],
    name: "GeneralDacProtocol",
  },
];
// const cmitNavs = [
//   {
//     id: 111524486387,
//     icon: <ListIcon />,
//     label: <MultiLanTxt tid="ACCOUNT_NUMBER" />,
//     to: "/account-number",
//     items: [],
//   },
//   {
//     id: 211496379,
//     icon: <MapIcon />,
//     label: <MultiLanTxt tid="BRANCH" />,
//     to: "/branch",
//     items: [],
//   },
//   {
//     id: 350002581,
//     icon: <CorporateFareIcon />,
//     label: <MultiLanTxt tid="CHEKNAZDESANDOGH_NAVBAR" />,
//     to: "/to-fund",
//     items: [],
//   },
//   {
//     id: 454679138,
//     icon: <CalendarMonthIcon />,
//     label: <MultiLanTxt tid="CHECK" />,
//     to: "/checks",
//     items: ceckItems,
//   },
// ];
const ospNavs = [
  {
    id: 74136985297,
    icon: <CorporateFareOutlinedIcon />,
    label: "گزارش قیمت ها",
    to: "/prices",
    items: [],
    name: "SkuSeller",
  },
  // {
  //   id: 15951951951,
  //   icon: <ApartmentOutlinedIcon />,
  //   label: "لیست تخفیف‌ها",
  //   to: "/discount",
  //   items: [],
  //   name: "Discount",
  // },
  {
    id: 159541951,
    icon: <ApartmentOutlinedIcon />,
    label: "پاسخ انتقادات و پیشنهادات",
    to: "/response",
    items: [],
    name: "Replay",
  },
  {
    id: 8852361490,
    icon: <BadgeOutlinedIcon />,
    label: "طرف حساب",
    to: "/account-party",
    items: [],
    name: "AccountParty",
  },
  {
    id: 112365811477,
    icon: <CalendarMonthOutlinedIcon />,
    label: "برند",
    to: "/brand",
    items: [],
    name: "Brand",
  },
  {
    id: 112365811478,
    icon: <CalendarMonthOutlinedIcon />,
    label: "محموله",
    to: "/cargo",
    items: [],
    name: "Cargo",
  },
  {
    id: 461113752809,
    icon: <ListAltOutlinedIcon />,
    label: "تگ محصول-زیرگروه",
    to: "/sku-tag-sub-group",
    items: [],
    name: "SkuTagSubGroup",
  },
  {
    id: 461375222809,
    icon: <ListAltOutlinedIcon />,
    label: "تگ محصول-گروه",
    to: "/sku-tag-group",
    items: [],
    name: "SkuTagGroup",
  },
  {
    id: 461375234809,
    icon: <ListAltOutlinedIcon />,
    label: "تگ محصول",
    to: "/sku-tag",
    items: [],
    name: "SkuTag",
  },
  {
    id: 5500695222112,
    icon: <MapIcon />,
    label: "شناسه منحصر به فرد محصول",
    to: "/uidp",
    items: [],
    name: "UIDP",
  },
  {
    id: 66000148,
    icon: <MapIcon />,
    label: "مشتری انتخابی",
    to: "/customer-candidate",
    items: [],
    name: "CustomerCandidate",
  },
  {
    id: 6465132180139,
    icon: <ApartmentOutlinedIcon />,
    label: "محصول",
    to: "/sku",
    items: [],
    name: "Sku",
  },
  {
    id: 6465032182139,
    icon: <ApartmentOutlinedIcon />,
    label: "تغییر محصول",
    to: "/sku-edit",
    items: [],
    name: "SkuEdit",
  },
  {
    id: 6454444465482139,
    icon: <ApartmentOutlinedIcon />,
    label: <MultiLanTxt tid="Pku" />,
    to: "/pku",
    items: [],
    name: "Pku",
  },
  {
    id: 6465130182139,
    icon: <ApartmentOutlinedIcon />,
    label: <MultiLanTxt tid="PkuEdit" />,
    to: "/pku-edit",
    items: [],
    name: "PkuEdit",
  },
  {
    id: 6454984654182139,
    icon: <ApartmentOutlinedIcon />,
    label: "WarehouseGroup",
    to: "/warehouse-group",
    items: [],
    name: "WarehouseGroup",
  },
  {
    id: 68946544182139,
    icon: <ApartmentOutlinedIcon />,
    label: "تخفیفات ویژه",
    to: "/special-discount",
    items: [],
    name: "SpecialDiscount",
  },
  {
    id: 6894654546545182139,
    icon: <ApartmentOutlinedIcon />,
    label: "بسته های تخفیفات ویژه",
    to: "/special-discount-box",
    items: [],
    name: "SpecialDiscountBox",
  },
  {
    id: 689466544444182139,
    icon: <ApartmentOutlinedIcon />,
    label: "پیشنهادات تخفیفات ویژه",
    to: "/special-discount-offer",
    items: [],
    name: "SpecialDiscountOffer",
  },
  {
    id: 6454984653182139,
    icon: <ApartmentOutlinedIcon />,
    label: <MultiLanTxt tid="WarehouseNote" />,
    to: "/warehouse-note",
    items: [],
    name: "WarehouseNote",
  },
  {
    id: 64584653182139,
    icon: <ApartmentOutlinedIcon />,
    label: <MultiLanTxt tid="SelectWarehouseNotes" />,
    to: "/select-warehouse-notes/edit",
    items: [],
    name: "WarehouseNote",
  },
  {
    id: 645468455564182139,
    icon: <ApartmentOutlinedIcon />,
    label: "ProductNature",
    to: "/product-nature",
    items: [],
    name: "ProductNature",
  },
  {
    id: 6465654541182139,
    icon: <ApartmentOutlinedIcon />,
    label: "MeasurementUnit",
    to: "/measurement-unit",
    items: [],
    name: "MeasurementUnit",
  },
  {
    id: 22558846,
    icon: <ApartmentOutlinedIcon />,
    label: "انبار",
    to: "/warehouse",
    items: [],
    name: "Warehouse",
  },
  {
    id: 4491637,
    icon: <ApartmentOutlinedIcon />,
    label: "محصولات قابل فروش",
    to: "/selling-product",
    items: [],
    name: "SellingProduct",
  },
  {
    id: 2000564,
    icon: <ApartmentOutlinedIcon />,
    label: "برگه انبار",
    to: "/warehouse-operation",
    items: [],
    name: "WarehouseOperation",
  },
  {
    id: 9960014,
    icon: <BusinessCenterOutlinedIcon />,
    label: "کاربر",
    to: "/user",
    items: [],
    name: "User",
  },
  {
    id: 1465379820,
    icon: <BusinessCenterOutlinedIcon />,
    label: "پک فروش",
    to: "/sale-pack",
    items: [],
    name: "SalePack",
  },
  {
    id: 110023548952,
    icon: <AccessLogo />,
    label: "کارکنان",
    to: "/staffs",
    items: ospStaffItems,
    containerOfEntitys: ["ChiefManagementStaff", "SalePersonStaff", "LogisticStaff"],
  },
  {
    id: 356487931,
    icon: <ChartLogo />,
    label: "چارت",
    to: "/charts",
    items: ospChartItems,
    containerOfEntitys: ["ChiefManagementChart", "SalePersonChart", "LogisticChart"],
  },
  {
    id: 498541151521,
    icon: <CalendarMonthOutlinedIcon />,
    label: "دسته بندی محصولات",
    to: "/productCategory",
    items: [],
    name: "ProductCategory",
  },
  {
    id: 4564565411521,
    icon: <CalendarMonthOutlinedIcon />,
    label: "گروه کالا",
    to: "/productGroup",
    items: [],
    name: "ProductGroup",
  },
];
const hrinfNavs = [
  // {
  //   id: 556458448,
  //   name: "Personnel",
  //   icon: <PersonOutlineOutlinedIcon />,
  //   label: <MultiLanTxt tid="personel" />,
  //   to: "/personnel",
  //   items: [],
  // },
  // {
  //   id: 554524448,
  //   containerOfEntitys: ["Contract", "WorkCycle"],
  //   icon: <AssignmentOutlinedIcon />,
  //   label: <MultiLanTxt tid="Contract" />,
  //   to: "/contract",
  //   items: contractItems,
  // },
  // {
  //   id: 798794221646,
  //   icon: <AdminPanelSettingsIcon />,
  //   label: <MultiLanTxt tid="ADMIN" />,
  //   name: "HRAdminStaff",
  //   to: "/hr-admin-person",
  //   items: [],
  // },
  // {
  //   id: 3516345136521,
  //   icon: <AdminPanelSettingsIcon />,
  //   label: <MultiLanTxt tid="CHART" />,
  //   name: "HRAdminChart",
  //   to: "/hr-admin-chart",
  //   items: [],
  // },
  // {
  //   id: 7982221646,
  //   icon: <MenuBookRoundedIcon />,
  //   label: <MultiLanTxt tid="DEFINE_MAJOR" />,
  //   name: "Major",
  //   to: "/major",
  //   items: [],
  // },
  // {
  //   id: 845221646,
  //   icon: <LocationCityRoundedIcon />,
  //   label: <MultiLanTxt tid="EducationalInstitute" />,
  //   name: "EducationalInstitute",
  //   to: "/educational-institute",
  //   items: [],
  // },
  // {
  //   id: 899514753,
  //   icon: <CalendarMonthIcon />,
  //   label: <MultiLanTxt tid="organizational_positions" />,
  //   name: "nnn",
  //   to: "/organizational_position",
  //   items: [],
  // },
  // {
  //   id: 654654656,
  //   icon: <HomeOutlinedIcon />,
  //   label: <MultiLanTxt tid="LEAVE" />,
  //   containerOfEntitys: ["leaveApp"],
  //   to: "/leave",
  //   items: morakhasiKhaliItems,
  // },
  {
    id: 541650321,
    icon: <AccountGroup />,
    label: "درخواست های کار",
    to: "/job-apply",
    items: [],
    name: "JobApply",
  },
  // {
  //   id: 541654321,
  //   icon: <AccountGroup />,
  //   label: <MultiLanTxt tid="CorporateChartSpecification" />,
  //   to: "/corporate-chart-specification",
  //   items: [],
  //   name: "CorporateChartSpecification",
  // },
  {
    id: 542412454321,
    icon: <AccountGroup />,
    label: "پرسنل شرکت",
    to: "/corporate-staff",
    items: [],
    name: "CorporateStaff",
  },
  {
    id: 533441654321,
    icon: <AccountGroup />,
    label: <MultiLanTxt tid="ORGANIZATIONAL_TITLE_SALARY_DIFFERENCE" />,
    to: "/hrinf/organizational-title-salary-difference",
    items: [],
    name: "OrganizationalTitleSalaryDifference",
  },
  {
    id: 53364321,
    icon: <AccountGroup />,
    label: <MultiLanTxt tid="NATIONALCODE_CELLPHONE_OF_PERSONNEL" />,
    to: "/hrinf/national-code-of-personnel",
    items: [],
    name: "NationalCodeCellphoneOfPersonnel",
  },

  {
    id: 541654132,
    icon: <AccountGroup />,
    label: "لیست پرسنل",
    to: "/personnel-document-digitization",
    items: [],
    name: "PersonnelDocumentDigitization",
  },
];
// const ssoNavs = [
//   {
//     id: 4987546512321,
//     icon: <Person3OutlinedIcon />,
//     label: <MultiLanTxt tid="USER" />,
//     to: "/user",
//     items: [],
//     name: "User",
//   },
//   {
//     id: 16546526532165,
//     icon: <SettingsApplicationsOutlinedIcon />,
//     label: <MultiLanTxt tid="SERVICE" />,
//     to: "/service",
//     items: [],
//     name: "Service",
//   },
// ];
const pacNavs = [
  {
    id: 777333569,
    icon: <AccountGroup />,
    label: "گروه حساب بانکی",
    to: "/posAccountControl/bank-account-group",
    items: [],
    name: "BankAccountGroup",
  },
  {
    id: 897465423466,
    icon: <CreditCardOutlinedIcon />,
    label: "حساب بانکی",
    to: "/posAccountControl/bank-account",
    items: [],
    name: "BankAccount",
  },
  {
    id: 8984321222,
    icon: <RequestQuoteOutlinedIcon />,
    label: "واریزی‌های حساب بانکی",
    to: "/posAccountControl/bank-account-input",
    items: [],
    name: "BankAccountInput",
  },
  {
    id: 777444111,
    icon: <PointOfSaleOutlinedIcon />,
    label: "دستگاه کارتخوان",
    to: "/posAccountControl/pos-device",
    items: [],
    name: "PosDevice",
  },
  {
    id: 22669988,
    icon: <ReceiptLongOutlinedIcon />,
    label: "واریزی‌های دستگاه کارتخوان",
    to: "/posAccountControl/pos-input",
    items: [],
    name: "PosInput",
  },
  {
    id: 8885590444,
    icon: <WorkspacesOutlinedIcon />,
    label: "حوزه‌های تحصیلداران",
    to: "/posAccountControl/collection-pipeline",
    items: [],
    name: "CollectionPipeline",
  },
  {
    id: 663374118524,
    icon: <PointOfSaleOutlinedIcon />,
    label: "اختصاص دستگاه کارتخوان",
    to: "/posAccountControl/pos-allocation",
    items: [],
    name: "PosAllocation",
  },
  {
    id: 85000001,
    icon: <DashboardCustomizeOutlinedIcon />,
    label: "شعبه‌ها",
    to: "/posAccountControl/branch",
    items: [],
    name: "Branch",
  },
  {
    id: 11511,
    icon: <AccountTreeOutlinedIcon />,
    label: "جایگاه‌های سازمانی",
    to: "/posAccountControl/charts",
    items: pacChartItems,
    containerOfEntitys: ["TreasurerChart", "CollectorChart"],
  },
  {
    id: 55558999,
    icon: <GroupsOutlinedIcon />,
    label: "تخصیص کاربر به جایگاه سازمانی",
    to: "/posAccountControl/staffs",
    items: pacStaffItems,
    containerOfEntitys: ["TreasurerStaff", "CollectorStaff"],
  },
];
const pavNavs = [
  {
    id: 4987954621,
    icon: <CalendarMonthOutlinedIcon />,
    label: "اطلاعات شماره پروانه",
    to: "/productAuthenticityVerification/license-info",
    items: [],
    name: "LicenseInfo",
  },
  {
    id: 124124,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="REGULATORY_CHART" />,
    to: "/productAuthenticityVerification/regulatory-chart",
    items: [],
    name: "RegulatoryChart",
  },
  {
    id: 34634621,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="REGULATORY_STAFF" />,
    to: "/productAuthenticityVerification/regulatory-staff",
    items: [],
    name: "RegulatoryStaff",
  },
];
const marketVisitNavs = [
  {
    id: 49545621,
    icon: <CalendarMonthOutlinedIcon />,
    label: "مارکت ویزیت",
    to: "/marketVisit/SupervisorMarketVisit",
    items: [],
    name: "BankAccount",
  },
  {
    id: 492146541,
    icon: <CalendarMonthOutlinedIcon />,
    label: "مارکت ویزیت مدیران منطقه",
    to: "/marketVisit/AdminMarketVisit",
    items: [],
    name: "BankAccount",
  },
];
const binfNavs = [
  {
    id: 5502698413,
    icon: <BusinessCenterOutlinedIcon />,
    label: <MultiLanTxt tid="BUSINESS_UNIT" />,
    to: "/binf/base-information",
    items: baseInformationItems,
    containerOfEntitys: [
      "BusinessUnit",
      // , "BURelation"
    ],
  },
  {
    id: 55541521413,
    icon: <BusinessCenterOutlinedIcon />,
    label: "جایگاه سازمانی مدیریت اطلاعات پایه",
    to: "/bu-and-office-admin-chart",
    items: [],
    name: "BuAndOfficeAdminChart",
  },
  {
    id: 74136985297,
    icon: <CorporateFareOutlinedIcon />,
    label: <MultiLanTxt tid="ORGANIZATION" />,
    to: "/binf/organizations",
    items: organizationItems,
    containerOfEntitys: ["Organization", "OrganizationTag"],
  },
  {
    id: 15951951951,
    icon: <ApartmentOutlinedIcon />,
    label: <MultiLanTxt tid="OFFICES" />,
    to: "/binf/office",
    items: officeItems,
    containerOfEntitys: ["Office", "OfficeType"],
  },
  {
    id: 8852361490,
    icon: <BadgeOutlinedIcon />,
    label: <MultiLanTxt tid="PERSONS" />,
    to: "/binf/person",
    items: personItems,
    containerOfEntitys: ["Person", "PersonTag"],
  },
  {
    id: 112365811477,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="CALENDAR" />,
    to: "/binf/calendar",
    items: calendarItems,
    containerOfEntitys: ["AnnualOccasion", "AnnualOccasionTag", "WeeklyHoliday", "AdhocHoliday"],
  },
  {
    id: 4613752809,
    icon: <ListAltOutlinedIcon />,
    label: <MultiLanTxt tid="TITLES" />,
    to: "/binf/titles",
    items: titleItems,
    containerOfEntitys: ["AddressType", "ContactInfoType"],
  },
  {
    id: 5500695222112,
    icon: <MapIcon />,
    label: <MultiLanTxt tid="CITIES_AND_PROVINCES" />,
    to: "/binf/cities-&-provinces",
    items: cityAndProvinceItems,
    containerOfEntitys: ["City", "Province"],
  },
  {
    id: 6465132182139,
    icon: <ApartmentOutlinedIcon />,
    label: <MultiLanTxt tid="Admin" />,
    to: "/binf/admin",
    items: binfAdminItems,
    containerOfEntitys: [
      "BINFBusinessAdminChart",
      "BINFBusinessAdminStaff",
      "BINFPersonAdminChart",
      "BINFPersonAdminStaff",
    ],
  },
];
const marketPriceMonitorNavs = [
  {
    id: 498729521,
    icon: <CalendarMonthOutlinedIcon />,
    label: "لیست گزارش",
    to: "/market-price-monitor/online-shop-report",
    items: [],
    name: "OnlineShopReport",
  },
];
const saleRepresentativesNavs = [
  {
    id: 451657968787241,
    icon: <ListAltOutlinedIcon />,
    label: "گزارش فروش روزانه مشاوران",
    to: "/beauty-advisor-report",
    items: [],
    name: "BeautyAdvisorReport",
  },
  //   {
  //   id: 451657968787241,
  //   icon: <ListAltOutlinedIcon />,
  //   label: "گزارش فروش روزانه مشاوران",
  //   to: "/beauty-advisor-report/add",
  //   items: [],
  //   name: "BeautyAdvisorReport",
  // },
  {
    id: 4654627241,
    icon: <ListAltOutlinedIcon />,
    label: "نقطه فروش",
    to: "/point-of-sale",
    items: [],
    name: "PointOfSale",
  },
  {
    id: 447241,
    icon: <ListAltOutlinedIcon />,
    label: "جایگاه سازمانی مشاوران",
    to: "/beauty-advisor-chart",
    items: [],
    name: "BeautyAdvisorChart",
  },
  {
    id: 4472841,
    icon: <ListAltOutlinedIcon />,
    label: "چارت مدیریت منابع انسانی",
    to: "/srm-hr-chart",
    items: [],
    name: "SrmHrChart",
  },
  {
    id: 465987157851,
    icon: <ListAltOutlinedIcon />,
    label: "نمایندگان فروش",
    to: "/sale-representative",
    items: [],
    name: "SaleRepresentative",
  },
  {
    id: 465927851,
    icon: <ListAltOutlinedIcon />,
    label: "چارت ناظرین مشاوران",
    to: "/beauty-advisor-supervision-chart",
    items: [],
    name: "BeautyAdvisorSupervisionChart",
  },
  {
    id: 497851,
    icon: <ListAltOutlinedIcon />,
    label: "چارت پشتیبان سیستم SRM",
    to: "/srm-software-support-chart",
    items: [],
    name: "SrmSoftwareSupportChart",
  },
  {
    id: 4659278512,
    icon: <ListAltOutlinedIcon />,
    label: "حوزه‌های فعالیت ناظرین مشاوران",
    to: "/beauty-advisor-supervision-sector",
    items: [],
    name: "BeautyAdvisorSupervisionSector",
  },
  {
    id: 4659295712,
    icon: <ListAltOutlinedIcon />,
    label: "حوزه‌های فعالیت پشتیبان فروش",
    to: "/sale-support-geo-division-sector",
    items: [],
    name: "SaleSupportGeoDivisionSector",
  },
  {
    id: 465900578787241,
    icon: <ListAltOutlinedIcon />,
    label: <MultiLanTxt tid="BeautyAdvisorSupervisorReport" />,
    to: "/beauty-advisor-supervisor-report",
    items: [],
    name: "BeautyAdvisorSupervisorReport",
  },
  {
    id: 46590057870241,
    icon: <ListAltOutlinedIcon />,
    label: <MultiLanTxt tid="UserInformation" />,
    to: "/user-information",
    items: [],
    name: "UserInformation",
  },
];
const medRepNavs = [
  {
    id: 4497851,
    icon: <ListAltOutlinedIcon />,
    label: "چارت مدیریت امور پزشکی",
    to: "/medical-affairs-chart",
    items: [],
    name: "MedicalAffairsChart",
  },
  {
    id: 4397851,
    icon: <ListAltOutlinedIcon />,
    label: "چارت نمایندگان علمی",
    to: "/med-rep-chart",
    items: [],
    name: "MedRepChart",
  },
  {
    id: 4927851,
    icon: <ListAltOutlinedIcon />,
    label: "مدیریت انبار و موجودی SRM",
    to: "/srm-stock-management-chart",
    items: [],
    name: "SrmStockManagementChart",
  },
  {
    id: 4971851,
    icon: <ListAltOutlinedIcon />,
    label: "چارت مدیریت اقلام قابل انبارش",
    to: "/stockable-object-management-chart",
    items: [],
    name: "StockableObjectManagementChart",
  },
];
const mlmNavs = [
  {
    id: 484784512,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جایگاه سازمانی مدیریت بازاریابان",
    to: "/nrm-chart",
    items: [],
    name: "NrmChart",
  },
  {
    id: 4689874965414512,
    icon: <CalendarMonthOutlinedIcon />,
    label: "تعرفه‌ی ارسال مرسوله",
    to: "/delivery-tariff",
    items: [],
    name: "DeliveryTariff",
  },
  {
    id: 4665849844114512,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جعبه ها",
    to: "/freight-box",
    items: [],
    name: "FreightBox",
  },
  {
    id: 654654654456456,
    icon: <CalendarMonthOutlinedIcon />,
    label: " محصولات مرجوعی",
    to: "/contract-termination-request",
    items: [],
    name: "ContractTerminationRequest",
  },
  {
    id: 684654165,
    icon: <CalendarMonthOutlinedIcon />,
    label: " تغییر بالادستی",
    to: "/royal/add",
    items: [],
    name: "RoyalZhickNetworkMarketer",
  },
  {
    id: 48984511,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جایگاه سازمانی مدیریت دسته بندی محصولات",
    to: "/category_management_chart",
    items: [],
    name: "CategoryManagementChart",
  },
  {
    id: 48414441,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جایگاه سازمانی پشتیبانی فروش",
    to: "/sale-support-chart",
    items: [],
    name: "SaleSupportChart",
  },
  {
    id: 451651844441,
    icon: <CalendarMonthOutlinedIcon />,
    label: "مدیریت محصولات",
    to: "/product-managment-chart",
    items: [],
    name: "ProductManagementChart",
  },
  {
    id: 451654144441,
    icon: <CalendarMonthOutlinedIcon />,
    label: "تقسیمات جغرافیایی",
    to: "/geographicalDivision",
    items: [],
    name: "GeographicalDivision",
  },
  {
    id: 451755645514144441,
    icon: <CalendarMonthOutlinedIcon />,
    label: "مرجوع",
    to: "/defective-product-statement",
    items: [],
    name: "DefectiveProductStatement",
  },
  {
    id: 5645514140441,
    icon: <CalendarMonthOutlinedIcon />,
    label: "CustomerReceivableResolution",
    to: "/customer-receivable-resolution",
    items: [],
    name: "CustomerReceivableResolution",
  },

  {
    id: 4516415412441,
    icon: <CalendarMonthOutlinedIcon />,
    label: "دسته بندی محصولات",
    to: "/productCategory",
    items: [],
    name: "ProductCategory",
  },
  {
    id: 45165412441,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جایگاه سازمانی پشتیبانی فروشنده ها",
    to: "/seller-support-chart",
    items: [],
    name: "SellerSupportChart",
  },
  {
    id: 45165418441,
    icon: <BusinessCenterOutlinedIcon />,
    label: "کیف‌پول",
    to: "/wallet",
    items: [],
    name: "WalletTransaction",
  },
  {
    id: 4516541801241,
    icon: <ListAltOutlinedIcon />,
    label: "نارضایتی",
    to: "/complaint-case",
    items: [],
    name: "ComplaintCase",
  },
  {
    id: 112360811477,
    icon: <CalendarMonthOutlinedIcon />,
    label: "محصولات فروشنده",
    to: "/sku-seller",
    items: [],
    name: "SkuSeller",
  },
  {
    id: 851001654,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="InvoiceReport" />,
    to: "/invoice-report",
    items: [],
    name: "SaleOrder",
  },
  {
    id: 851001655,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="SaleOrderReport" />,
    to: "/sale-order-report",
    items: [],
    name: "SaleOrder",
  },
];
const financialNavs = [
  {
    id: 498652251521,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جایگاه سازمانی حقوق و دستمزد",
    to: "/payroll-chart",
    items: [],
    name: "PayrollChart",
  },
  {
    id: 85154654,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جایگاه سازمانی بودجه بندی",
    to: "/budgetting-chart",
    items: [],
    name: "BudgetingChart",
  },
  {
    id: 851000654,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="FinancialInfoChart" />,
    to: "/financial-info-chart",
    items: [],
    name: "FinancialInfoChart",
  },
  {
    id: 851000656,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="ProcurementChart" />,
    to: "/procurement-chart",
    items: [],
    name: "ProcurementChart",
  },
  {
    id: 85114140654,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="AccountClass" />,
    to: "/account-class",
    items: [],
    name: "AccountClass",
  },
  {
    id: 85004140654,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="GeneralLedgerAccount" />,
    to: "/general-ledger-account",
    items: [],
    name: "GeneralLedgerAccount",
  },
  {
    id: 8511110654,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="SubsidiaryAccount" />,
    to: "/subsidiary-account",
    items: [],
    name: "SubsidiaryAccount",
  },
  {
    id: 8901110654,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="BankBranch" />,
    to: "/bank-branch",
    items: [],
    name: "BankBranch",
  },
  {
    id: 89011101254,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="DetailAccountGroup" />,
    to: "/detail-account-group",
    items: [],
    name: "DetailAccountGroup",
  },
  {
    id: 890991054,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="FiscalYear" />,
    to: "/fiscal-year",
    items: [],
    name: "FiscalYear",
  },
  {
    id: 890990054,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="PurchaseProforma" />,
    to: "/purchase-proforma",
    items: [],
    name: "PurchaseProforma",
  },
  {
    id: 890944345,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="PurchaseReturnProformaWithoutUid" />,
    to: "/purchase-return-proforma-without-uid",
    items: [],
    name: "PurchaseReturnProformaWithoutUid",
  },
  {
    id: 890990053,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="PurchaseInvoice" />,
    to: "/purchase-invoice",
    items: [],
    name: "PurchaseInvoice",
  },
  {
    id: 890990055,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="AccountingDocument" />,
    to: "/accounting-document",
    items: [],
    name: "AccountingDocument",
  },
];
const executiveNavs = [
  {
    id: 49865201521,
    icon: <CalendarMonthOutlinedIcon />,
    label: "جایگاه سازمانی حقوقی",
    to: "/legal-chart",
    items: [],
    name: "LegalChart",
  },
  {
    id: 49865201521,
    icon: <SecurityIcon />,
    label: <MultiLanTxt tid="SecurityChart" />,
    to: "/security-chart",
    items: [],
    name: "SecurityChart",
  },
];
const hcmNavs = [
  {
    id: 541321,
    icon: <AccountGroup />,
    label: "جایگاه سازمانی",
    to: "/corporate-chart",
    items: [],
    name: "CorporateChart",
  },
  {
    id: 54741521,
    icon: <AccountGroup />,
    label: "جایگاه سازمانی منابع انسانی",
    to: "/hr-admin-chart",
    items: [],
    name: "HrAdminChart",
  },
  {
    id: 541541521,
    icon: <AccountGroup />,
    label: "جایگاه سازمانی امور اداری",
    to: "/administrative-affairs-chart",
    items: [],
    name: "AdministrativeAffairsChart",
  },
  {
    id: 49865515201,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="JobPosition" />,
    to: "/job-position",
    items: [],
    name: "JobPosition",
  },
  {
    id: 498652251522,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="HrSegment" />,
    to: "/hr-segment",
    items: [],
    name: "HrSegment",
  },
  {
    id: 498652251523,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="InterviewSchedulingAndRescheduling" />,
    to: "/interview-scheduling-and-rescheduling",
    items: [],
    name: "InterviewSchedulingAndRescheduling",
  },
  {
    id: 49051523,
    label: <MultiLanTxt tid="CandidateScreening" />,
    icon: <CalendarMonthOutlinedIcon />,
    to: "/candidate-screening",
    items: [],
    name: "CandidateScreening",
  },
  {
    id: 498652251524,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="CognitiveTestQuestion" />,
    to: "/cognitive-test-question",
    items: [],
    name: "CognitiveTestQuestion",
  },
  {
    id: 423,
    label: <MultiLanTxt tid="CandidateAssessment" />,
    icon: <CalendarMonthOutlinedIcon />,
    to: "/candidate-assessment",
    items: [],
    name: "CandidateAssessment",
  },
  {
    id: 40865225,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="CandidateSelection" />,
    to: "/candidate-selection",
    items: [],
    name: "CandidateSelection",
  },
  {
    id: 408652256,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="Hiring" />,
    to: "/hiring",
    items: [],
    name: "Hiring",
  },
  {
    id: 408652257,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="DocumentSubmissionScheduling" />,
    to: "/document-submission-scheduling",
    items: [],
    name: "DocumentSubmissionScheduling",
  },
  {
    id: 541654321,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="OrganizationalTitleSpecification" />,
    to: "/organizational-title-specification",
    items: [],
    name: "OrganizationalTitleSpecification",
  },
];
const gsmNavs = [
  {
    id: 498551,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="GsmMessageLog" />,
    to: "/gsm-message-log",
    items: [],
    name: "GsmMessageLog",
  },
  {
    id: 771522,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="GsmRouting" />,
    to: "/gsm-routing",
    items: [],
    name: "GsmRouting",
  },
];

const delegationNavs = [
  {
    id: 499551,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="myDelegations" />,
    to: "/define-delegation-by-me",
    items: [],
    name: "Delegation",
  },
  {
    id: 22622,
    icon: <CalendarMonthOutlinedIcon />,
    label: <MultiLanTxt tid="delegatedToMe" />,
    to: "/define-delegation-to-me",
    items: [],
    name: "Delegation",
  },
];

const correspondenceNavs = [
  {
    id: 12344321,
    icon: <InboxOutlinedIcon />,
    label: <MultiLanTxt tid="MessagesInbox" />,
    to: "/inbox",
    items: [],
    name: "CorrespondenceReceiverRouting",
  },
  // {
  //   id: 67899876,
  //   icon: <SendOutlinedIcon />,
  //   label: <MultiLanTxt tid="Sent" />,
  //   to: "/sent",
  //   items: [],
  //   name: "Sent",
  // },
  // {
  //   id: 123098655612340987,
  //   icon: <DraftsOutlinedIcon />,
  //   label: <MultiLanTxt tid="Drfats" />,
  //   to: "/drafts",
  //   items: [],
  //   name: "Drfats",
  // },
];

// ===========================================================================***ALL SYSTEMS***===========================================================================

const allSystems = [
  {
    id: 885314654621,
    packageNames: ["general", "baseKit"],
    label: "مدیریت سیستم",
    sidebarNavigations: coreSystemNavs,
  },
  {
    id: 77538999514,
    packageNames: ["onlineShopPortal"],
    label: "پرتال فروش آنلاین",
    sidebarNavigations: ospNavs,
  },
  {
    id: 1114446,
    packageNames: ["productAuthenticityVerification"],
    label: "سیستم اعتبار سنجی uid محصولات",
    sidebarNavigations: pavNavs,
  },
  {
    id: 1144362795,
    packageNames: ["posAccountControl"],
    label: "کنترل حساب دستگاه های کارتخوان",
    sidebarNavigations: pacNavs,
  },
  {
    id: 64565,
    packageNames: ["hrinf"],
    label: "منابع انسانی",
    sidebarNavigations: hrinfNavs,
  },
  {
    id: 11443628795,
    packageNames: ["binf"],
    label: <MultiLanTxt tid="BINF" />,
    sidebarNavigations: binfNavs,
  },
  {
    id: 11958495,
    packageNames: ["marketPriceMonitor"],
    label: "گزارش آنلاین شاپ‌ها",
    sidebarNavigations: marketPriceMonitorNavs,
  },
  {
    id: 18741995,
    packageNames: ["mlm"],
    label: "بازاریابان هوشمند کارافرین",
    sidebarNavigations: mlmNavs,
  },
  {
    id: 187654654995,
    packageNames: ["saleRepresentatives"],
    label: "نمایندگان فروش",
    sidebarNavigations: saleRepresentativesNavs,
  },
  {
    id: 187399995,
    packageNames: ["saleRepresentatives"],
    label: "نمایندگان علمی",
    sidebarNavigations: medRepNavs,
  },
  {
    id: 187658495,
    packageNames: ["financial", "finf"],
    label: "مالی",
    sidebarNavigations: financialNavs,
  },
  {
    id: 18741545,
    packageNames: ["executive"],
    label: "اجرایی",
    sidebarNavigations: executiveNavs,
  },
  {
    id: 18741586,
    packageNames: ["correspondence"],
    label: "مکاتبات",
    sidebarNavigations: correspondenceNavs,
  },
  {
    id: 18741546,
    packageNames: ["hcm"],
    label: <MultiLanTxt tid="hcm" />,
    sidebarNavigations: hcmNavs,
  },
  {
    id: 12903,
    packageNames: ["gsm"],
    label: "GSM",
    sidebarNavigations: gsmNavs,
  },
  {
    id: 12907,
    packageNames: ["delegation"],
    label: <MultiLanTxt tid="Delegation" />,
    sidebarNavigations: delegationNavs,
  },
  // {
  //   id: 1541251545,
  //   packageNames: ["onlineShopPortal"],
  //   label: "پرتال فروش انلاین",
  //   sidebarNavigations: onlineShopPortalNavs,
  // },
  // { id: 1552607895, packageNames: ["cmit"], label: <MultiLanTxt tid="CMIT" />, sidebarNavigations: cmitNavs, }, { id: 77537446955, packageNames: ["hrinf", "hrlp"], label: <MultiLanTxt tid="HUMAN_RESOURCES" />, sidebarNavigations: hrinfNavs, }, { id: 6549684984924, packageNames: ["sso"], label: <MultiLanTxt tid="SINGLE_SIGN_ON" />, sidebarNavigations: ssoNavs, },
];
export default allSystems;
